import moment from 'moment';

import { offlineReportList_offlineReportList_list } from '../../typings/graphql-grid';
import { ReportRequestSetData } from '../../typings/reports';
import { ReportDomain, ReportDomainRequestData } from '../../typings/reportsDomain';

export function mapReportsDomainApiDataToClientData(
    reports?: Array<offlineReportList_offlineReportList_list>
): Array<ReportDomain> {
    return (reports || []).map((report: offlineReportList_offlineReportList_list) => {
        const { reportId, args, scheduledAt, reportState, reportUrl } = report;
        const now = moment().format('YYYYMM');

        const date = args
            ? JSON.parse(args)
            : {
                  monthTo: now,
                  monthFrom: now
              };

        return {
            id: reportId.toString(),
            buildDate: moment(scheduledAt),
            dateStart: moment(date.monthFrom, 'YYYY-MM'),
            dateEnd: moment(date.monthTo, 'YYYY-MM').endOf('month'),
            status: reportState,
            reportUrl: reportUrl
        };
    });
}

export function mapReportsDomainDatesToApiFormat(dates?: ReportRequestSetData): ReportDomainRequestData {
    if (dates === undefined) {
        const now = moment().format('YYYYMM');

        return {
            monthTo: now,
            monthFrom: now
        };
    }

    const { dateStart, dateEnd } = dates;

    return {
        monthTo: dateEnd.format('YYYYMM'),
        monthFrom: dateStart.format('YYYYMM')
    };
}
